import { render, staticRenderFns } from "./policeList.vue?vue&type=template&id=6e776d78&scoped=true&"
import script from "./policeList.vue?vue&type=script&lang=js&"
export * from "./policeList.vue?vue&type=script&lang=js&"
import style0 from "./policeList.vue?vue&type=style&index=0&id=6e776d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e776d78",
  null
  
)

export default component.exports